import { Check, Pencil } from "lucide-react";
import { brl, dateBR } from "../lib/format";
import { describe, discountText, estimate } from "../lib/benefits";
import { selectedBenefits } from "./AdmissionBenefits";

export const ADM_STEPS = ["Dados da contratação", "Estrutura e jornada", "Benefícios", "Revisão"];

export const Stepper = ({ step, setStep }) => (
  <ol className="grid grid-cols-4 gap-1.5" data-testid="adm-stepper">{ADM_STEPS.map((l, i) => {
    const n = i + 1;
    return (
      <li key={l}><button type="button" disabled={n >= step} onClick={() => setStep(n)} data-testid={`adm-step-${n}`} data-state={n < step ? "done" : n === step ? "current" : "todo"} className="w-full text-left space-y-1.5 disabled:cursor-default">
        <div className={`h-1.5 rounded-full ${n < step ? "bg-emerald-500" : n === step ? "bg-indigo-600" : "bg-slate-200"}`} />
        <div className={`text-[10px] sm:text-[11px] leading-tight flex items-center gap-1 ${n === step ? "font-semibold text-slate-900" : n < step ? "text-emerald-700" : "text-slate-400"}`}>{n < step && <Check className="h-3 w-3 shrink-0" />}{n}. {l}</div>
      </button></li>);
  })}</ol>);

const Block = ({ title, step, setStep, children, testid }) => (
  <div className="rounded-lg border p-3" data-testid={testid}>
    <div className="flex items-center justify-between mb-2"><div className="label-xs">{title}</div><button type="button" className="text-xs text-indigo-700 font-medium inline-flex items-center gap-1" data-testid={`${testid}-edit`} onClick={() => setStep(step)}><Pencil className="h-3 w-3" />Editar</button></div>
    {children}
  </div>);

const Item = ({ k, v }) => <div className="flex justify-between gap-3 text-sm"><span className="text-slate-500">{k}</span><span className="font-medium text-right">{v || "—"}</span></div>;

export function AdmissionReview({ data, bp, sel, setStep }) {
  const bens = selectedBenefits(bp, sel || {});
  const vt = (bp?.items || []).find((p) => p.category === "vt");
  return (
    <div className="space-y-3" data-testid="adm-review">
      <Block title="Funcionário" step={1} setStep={setStep} testid="adm-review-person">
        <Item k="Nome" v={data.name} /><Item k="CPF" v={data.cpf} /><Item k="Salário" v={data.salary ? brl(Number(data.salary), 2) : ""} /><Item k="Início" v={dateBR(data.start_date)} />
      </Block>
      <Block title="Estrutura e jornada" step={2} setStep={setStep} testid="adm-review-structure">
        <Item k="Cargo" v={data.position} /><Item k="Departamento" v={data.department} /><Item k="Unidade" v={data.unit} /><Item k="Centro de custo" v={data.cost_center} /><Item k="Jornada" v={data.workload} /><Item k="Escala" v={data.escala} />
      </Block>
      <Block title="Benefícios" step={3} setStep={setStep} testid="adm-review-benefits">
        {bens.length === 0 && <p className="text-sm text-slate-500">Nenhum benefício selecionado.</p>}
        {bens.map(({ policy, b }) => <div key={policy.id} className="text-sm py-1 border-t first:border-t-0" data-testid={`adm-review-ben-${policy.id}`}>
          <div className="font-medium">{policy.name}</div><div className="text-xs text-slate-500">{describe(b)} · {discountText(b)} · estimado {brl(estimate(b)[0], 2)}/mês · vigência {dateBR(data.start_date)}</div></div>)}
        {vt && !sel?.[vt.id]?.checked && <div className="text-sm py-1 border-t" data-testid="adm-review-vt-no"><span className="font-medium">{vt.name}</span> <span className="text-slate-500">— Não utiliza</span></div>}
      </Block>
    </div>);
}
